import React from "react";
import brandLogo from "../assets/estimation-station-logo.png";

export default function BrandMark({ size = "md", stacked = false, className = "" }) {
  const logoSize = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-8 w-8" : "h-10 w-10";
  const titleClass = size === "lg" ? "text-2xl" : size === "sm" ? "text-sm" : "text-lg";
  const subtitleClass = size === "lg" ? "text-[11px]" : "text-[10px]";

  return (
    <div className={`${stacked ? "flex flex-col items-center gap-2" : "flex items-center gap-3"} ${className}`.trim()}>
      <img src={brandLogo} alt="Estimation Station logo" className={`${logoSize} rounded-xl object-contain`} />
      <div className={stacked ? "text-center" : ""}>
        <p className={`${titleClass} font-semibold tracking-tight text-zinc-900`}>Estimation Station</p>
        <p className={`${subtitleClass} uppercase tracking-[0.18em] text-zinc-500`}>Estimate Intelligence</p>
      </div>
    </div>
  );
}
